export default __webpack_public_path__ + "static/media/edital11.6089c910.pdf";